import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'

export default function useLastConsumptionIndex(deviceId?: string) {
  const lastConsumptionIndexQuery = useQuery({
    queryKey: ['last-consumption-index', deviceId],
    queryFn: () => dataAPI.getLastConsumptionIndexSingleCounter({ device_name: deviceId }),
    enabled: !!deviceId, // Only run query if deviceId is provided
  })

  return {
    lastConsumptionIndexQuery: {
      data: lastConsumptionIndexQuery.data,
      isLoading: lastConsumptionIndexQuery.isLoading,
      isSuccess: lastConsumptionIndexQuery.isSuccess,
      isError: lastConsumptionIndexQuery.isError,
      error: lastConsumptionIndexQuery.error,
      refetch: lastConsumptionIndexQuery.refetch,
      isRefetching: lastConsumptionIndexQuery.isRefetching
    }
  }
}

